// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AILx","delete":"styles_delete__olh0N","update":"styles_update__3XMoj","add":"styles_add__2bCMS"};